import { render, staticRenderFns } from "./OfflineMessage.vue?vue&type=template&id=0c603c4d&scoped=true&"
import script from "./OfflineMessage.vue?vue&type=script&lang=js&"
export * from "./OfflineMessage.vue?vue&type=script&lang=js&"
import style0 from "./OfflineMessage.vue?vue&type=style&index=0&id=0c603c4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c603c4d",
  null
  
)

export default component.exports